import { useLocation } from 'react-router-dom';

/**
 * Custom hook for sidebar navigation logic
 * @returns {Object} Navigation utilities
 */
export const useSidebarNavigation = () => {
  const location = useLocation();

  /**
   * Checks if a given path is the current active route
   * Handles related routes (e.g., /emergency-substitutions-list is active for /emergency-* routes)
   * @param {string} path - The path to check
   * @returns {boolean} Whether the path is active
   */
  const isActive = (path) => {
    // Home/New chat should never be marked as active
    if (path === '/') return false;

    // Exact match
    if (location.pathname === path) return true;

    // Handle emergency substitution related routes
    if (path === '/emergency-substitutions-list') {
      return location.pathname.startsWith('/emergency-') ||
             location.pathname.startsWith('/create-emergency-');
    }

    // Handle knowledge base dedicated bases
    if (path === '/knowledge-base/dedicated') {
      return location.pathname.startsWith('/knowledge-base/dedicated');
    }

    // Handle onboarding workflows routes (includes builder, edit, etc.)
    if (path === '/onboarding/workflows') {
      return location.pathname.startsWith('/onboarding/workflows');
    }

    // Handle onboarding instances routes
    if (path === '/onboarding/instances') {
      return location.pathname.startsWith('/onboarding/instances');
    }

    return false;
  };

  return {
    isActive,
    currentPath: location.pathname,
  };
};
